import { useState, useEffect } from 'react'
import { getDeck } from '@/services/api'
import { DeckData } from '@/types/decks'

export function useDeckDetail(deckId: string | undefined) {
  const [deck, setDeck] = useState<DeckData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchDeck = async () => {
      if (!deckId) return;
      
      try {
        setLoading(true)
        console.log('Fetching deck:', deckId)
        const response = await getDeck(deckId.toString())
        console.log('Deck response:', response)
        setDeck(response.data)
      } catch (error) {
        console.error('Failed to fetch deck:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchDeck()
  }, [deckId])

  return { deck, loading }
} 